/**
 * Dev Session Store — persiste o access token do LOGIN DE DESENVOLVIMENTO
 * entre recargas de página (F5).
 *
 * Escopo estrito: só o dev-login (POST /bff/auth/dev-login) usa isto.
 * O login real via Supabase NUNCA toca este store — continua com o access
 * token só em memória (spec §11.9, ver src/store/token-store.ts), rehidratado
 * a cada boot via refresh_token em cookie HttpOnly (W1-104).
 *
 * Por que dev-login pode ir pro localStorage e o real não pode: o dev-login
 * não existe em produção (gate no backend, PPM_ENV=prod desliga o endpoint),
 * emite token só pra usuários semeados fixos (senha "dev") e só funciona
 * contra uma API local sem Supabase configurado — não há PII/sessão real em
 * risco. Sem isto, todo F5 em dev derrubava a sessão mesmo com o token ainda
 * válido no servidor (dev-login não tem refresh — devauth.go, TTL de 8h).
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DevSessionState {
  accessToken: string | null
  setAccessToken: (token: string | null) => void
}

export const useDevSessionStore = create<DevSessionState>()(
  persist(
    (set) => ({
      accessToken: null,
      setAccessToken: (accessToken) => set({ accessToken }),
    }),
    { name: 'ppm-dev-session' },
  ),
)
